import React from 'react';
import PropTypes from 'prop-types';
import {Field as BaseField} from 'react-final-form';
import {TextInput} from '@tenancy.nz/design-system';
import FieldLabel from './FieldLabel';
import {
  getFieldProps,
  objectRemoveEmpty,
  isFunction,
  isString,
} from '../utils/helpers';

function Field({
  children = undefined,
  Component = TextInput,
  name,
  defaultValue = undefined,
  key = undefined,
  parse = undefined,
  validate = undefined,
  type = 'text',
  label = '',
  ...rest
}) {
  const isRadioOrCheckbox = ['checkbox', 'radio'].includes(type);

  const fieldProps = objectRemoveEmpty({
    key,
    defaultValue,
    parse,
    validate,
    ...(isRadioOrCheckbox && {type}),
  });

  return (
    <BaseField name={name} {...fieldProps}>
      {({input, meta}) =>
        isFunction(children) ? (
          children({input, meta})
        ) : (
          <Component
            {...getFieldProps({input, meta})}
            {...(!isRadioOrCheckbox && {type, fullWidth: true})}
            label={
              isString(label) ? (
                <FieldLabel content={label} required={rest.required || false} />
              ) : (
                label
              )
            }
            {...rest}
            required={false}
          />
        )
      }
    </BaseField>
  );
}

Field.propTypes = {
  children: PropTypes.func,
  Component: PropTypes.node,
  defaultValue: PropTypes.any,
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  key: PropTypes.string,
  parse: PropTypes.func,
  type: PropTypes.string,
  validate: PropTypes.func,
};

export default Field;
